
(function () {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-cart-upsell-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.disabled) return;

    var card = btn.closest('[data-cart-upsell]');
    var sel = card && card.querySelector('.cart-upsell__variant');
    var id = sel && sel.value;
    if (!id) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '追加中…';

    
    var onCartPage = /\/cart(\/|$|\?)/.test(window.location.pathname) || document.body.classList.contains('template-cart');
    var cartEl = onCartPage ? null : (document.querySelector('cart-notification') || document.querySelector('cart-drawer'));
    var body = { items: [{ id: id, quantity: 1 }] };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { 
          btn.disabled = false; btn.textContent = label;
          return;
        }
        if (cartEl && res.sections && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(res);
        } else {
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
